import classNames from 'classnames'

import { FileIconType } from './types'
import {
  iconNameForType,
  mapContentTypeToIconType,
  mapExtensionToIconType,
} from './utils'
import { Icon, IconSize } from '@/Atomic/Atoms/Icon'
import './FileIcon.scss'

export type FileIconProps = {
  extension?: string
  contentType?: string
  /**
   * Optional icon name override (e.g. "coffee", "phone").
   * If provided, it will be rendered inside the same badge styling.
   */
  icon?: string
  /**
   * Optional type override for badge styling.
   * Useful when you want the badge look but a custom icon.
   */
  type?: FileIconType
  className?: string
  size?: IconSize
  showExtensionLabel?: boolean
}

export const FileIcon: React.FC<FileIconProps> = ({
  extension,
  contentType,
  icon,
  type: typeOverride,
  className,
  size = 'sm',
  showExtensionLabel = false,
}) => {
  const type =
    typeOverride ??
    (contentType
      ? mapContentTypeToIconType(contentType)
      : mapExtensionToIconType(extension))
  const iconName = icon || iconNameForType(type)
  const extensionLabel = (extension || '').trim().toUpperCase()

  return (
    <span className={classNames('file-icon-badge', `type-${type}`, className)}>
      <Icon
        icon={iconName}
        color={type == 'generic' ? undefined : 'white'}
        className={classNames(`icon-${size}`)}
      />
      {showExtensionLabel && extensionLabel && (
        <span className="file-extension-label">{extensionLabel}</span>
      )}
    </span>
  )
}
